function doAsyn (type, callback) {
    var EventType;

    if (!callback) {
        return;
    }

    if (type === 'gj') {
        EventType = 'TcsJSBridgeReady';
        if (typeof TcsJSBridge === 'object' && typeof TcsJSBridge.invoke === 'function') {
            callbackWrapper();
        } else {
            document.addEventListener(EventType, callbackWrapper);
        }
    } else if (type === 'wx') {
        EventType = 'WeixinJSBridgeReady';
        if (typeof WeixinJSBridge === 'object' && typeof WeixinJSBridge.invoke === 'function') {
            callbackWrapper();
        } else {
            document.addEventListener(EventType, callbackWrapper);
        }
    }

    function callbackWrapper () {
        callback();
        document.removeEventListener(EventType, callbackWrapper);
    }
}

module.exports = {
    wx: function (callback) {
        doAsyn('wx', callback);
    },
    gj: function (callback) {
        doAsyn('gj', callback);
    }
};
